import { Analytics } from './analytics';
import { ItemAction } from '../../../item/actions/item_action';

export class RelatedItemAnalytics extends Analytics {
    constructor() {
        super();
        ItemAction.RELATED_ITEM_EVENT.on((data) => {
            this.run(() => {
                const linkAnalyticsData = {
                    server: 'club/pc',
                    fName: 'おすすめの関連商品',
                    club: {
                        server: 'club/pc',
                        prop5: 'おすすめの関連商品',
                    }
                };
                window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
            });
        });
    }
}
